export default __webpack_public_path__ + "static/media/AnthonyPena_Resume_Sept2022.ac385cc1.pdf";